import styled from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
import { devices } from '../styles/viewports.styles';
import { Step } from '../views/Step';
export const FlowStepComponent = styled.div.withConfig({
  displayName: "AppViewComponentstyles__FlowStepComponent",
  componentId: "y189g5-0"
})(["", " display:grid;align-content:center;flex:1;", " @media ", "{align-content:start;}@media ", "{justify-content:center;align-content:center;}"], props => props.theme.embedded && `  justify-content: center;
  align-content: center;`, props => props['data-loading'] && `align-content:center;`, devices.tablet, devices.desktop);
export const ViewComponent = styled.div.withConfig({
  displayName: "AppViewComponentstyles__ViewComponent",
  componentId: "y189g5-1"
})(["", " display:grid;grid-template-rows:minmax(65vh,max-content) auto;grid-area:main;", " ", " @media ", "{width:100%;justify-self:center;grid-template-columns:50% 50%;grid-template-rows:auto;", "}@media ", "{max-width:calc(100% - 1 * (100% - 1201px));}"], props => props.theme.embedded && `grid-template-rows: auto;`, props => props.isFramedCentredStep && `grid-template-rows: minmax(55vh, max-content) auto;`, props => props.isWideStep && `grid-template-rows: 100%;`, devices.desktop, props => (props.isWideStep || props.isFramedCentredStep) && `grid-template-columns: 100%;`, devices.large);
/**
 * Embedded width calculated: Minimum of the max available witdth and the suggested width
 */

export const ContentHolder = styled.div.withConfig({
  displayName: "AppViewComponentstyles__ContentHolder",
  componentId: "y189g5-2"
})(["width:100%;", " @media ", ",@media ", ",{", "}@media ", "{width:", ";overflow:visible;", "}"], props => props.theme.embedded && `width: \\min(calc(100vw - 2 * 1.25rem), 28rem);`, devices.tablet, devices.desktop, props => props.isFramedCentredStep && `
      min-height: 700px;
      height: 100%;
      border-radius: 8px;
      border: 1px solid ${KOALA};
      box-shadow: 0px 4px 20px rgba(81, 111, 144, 0.2);
      padding-top: 40px;
      padding-bottom: 30px;
      padding-left: 48px;
      padding-right: 48px;
      `, devices.desktop, props => props.isFramedCentredStep ? '528px' : '450px', props => props.isWideStep && `width: 50rem;`);
export const MessagingContentHolder = styled.div.withConfig({
  displayName: "AppViewComponentstyles__MessagingContentHolder",
  componentId: "y189g5-3"
})(["width:100%;", " @media ", "{width:450px;overflow:visible;}"], props => props.theme.embedded && `width: \\min(calc(100vw - 2 * 1.25rem), 28rem);`, devices.desktop);
export const FlowStep = styled.div.withConfig({
  displayName: "AppViewComponentstyles__FlowStep",
  componentId: "y189g5-4"
})(["display:flex;flex-direction:column;"]);
export const LayoutTemplateContentContainer = styled.div.withConfig({
  displayName: "AppViewComponentstyles__LayoutTemplateContentContainer",
  componentId: "y189g5-5"
})(["", ""], props => props.shouldUseLayoutTemplate && `
    @media ${devices.tablet} {
    width: 572px;
    ${props.stepKey === Step.AhaMoment ? `width: 597px;` : ''}

    ${props.shouldRestrictWidth ? `
      padding-left: 48px;
      padding-right: 48px;
      width: 528px;
    ` : ''}
    ${props.stepKey === Step.Industry && props.isACQ134Variant ? `width: 652px !important;` : ''}
  }
      margin: auto;

`);
export const LayoutTemplateBelowTitleContainer = styled.div.withConfig({
  displayName: "AppViewComponentstyles__LayoutTemplateBelowTitleContainer",
  componentId: "y189g5-6"
})(["@media ", ",@media ", ",{", "}margin:auto;"], devices.tablet, devices.desktop, props => props.shouldRestrictWidth && props.shouldUseLayoutTemplate && `
      padding-left: 48px;
      padding-right: 48px;
      width: 528px;
    `);